import { cn } from "@/utils/functions/cn";

interface PageTitleProps {
  children: React.ReactNode;
  className?: string;
}

const PageTitle = ({ children, className }: PageTitleProps) => {
  return (
    <h1 className={cn(
      "text-2xl md:text-3xl lg:text-4xl font-bold mb-6 text-center",
      className
    )}>
      {children}{" "}
      <span className="text-brand-sky">MoovaTV</span>
    </h1>
  );
};

export default PageTitle;
